import { InvoiceMention } from '@allocab/allocab-passenger-shared-types';
import { z } from 'zod';

import { t } from '@frontend/shared';

export const PickerItemSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export type PickerItem = z.infer<typeof PickerItemSchema>;

export const isPickerItemValue = (value: unknown, mention: InvoiceMention): value is PickerItem =>
  !!value && mention.values.length > 0;

export const getMentionValue = (value: string | PickerItem, mention: InvoiceMention) =>
  isPickerItemValue(value, mention) ? value.value : value;

export const getMentionDefaultValue = (
  initialValue: string | undefined,
  mention: InvoiceMention,
): string | PickerItem | undefined => {
  const isPicker = mention.values.length > 0;

  if (isPicker) {
    return initialValue ? { value: initialValue, label: initialValue } : undefined;
  }

  return initialValue ?? '';
};

export const createRequiredStringSchema = (mention?: InvoiceMention) => {
  if (mention?.required) {
    return z
      .string({
        message: t('pwa.common.errors.input-x-is-required', { label: mention.label }),
      })
      .trim()
      .min(1, {
        message: t('pwa.common.errors.input-x-is-required', { label: mention.label }),
      });
  }
  return z.string().trim().optional().nullable();
};
